var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tmp"}),_c('v-card',[_c('v-card-title',{staticClass:"justify-center"},[_vm._v(" 저장 완료 문구 ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }